// extracted by mini-css-extract-plugin
export default {"wrapper":"orb_wrapper__hWO3h","orbCanvas":"orb_orbCanvas__kSx6P","overlay":"orb_overlay__p14Wj"};